(function () {
  'use strict';

  angular.module('app').component('accountPage', accountDetailComponent());

  function accountDetailComponent() {
    return {
      bindings: {},
      controller: AccountDetailCtrl,
      controllerAs: 'vm',
      templateUrl: './app/ajs/admin/accounts/account-page.component.html',
    };
  }

  AccountDetailCtrl.$inject = ['$location', '$routeParams', 'AccountService'];

  function AccountDetailCtrl($location, $routeParams, AccountService) {
    var vm = this;

    var itemId = $routeParams.id;
    vm.mode = $routeParams.mode;

    vm.onSavedItem = onSavedItem;
    vm.onCanceledItem = onCanceledItem;

    // Initializers
    getItem();

    function getItem() {
      if (itemId) {
        // edit
        vm.loadingItem = true;
        AccountService.getAccount(itemId).then(function (data) {
          vm.item = data;

          vm.loadingItem = false;
        });
      } else {
        vm.item = {};
      }
    }

    function onSavedItem() {
      $location.path('/accounts');
    }

    function onCanceledItem() {
      $location.path('/accounts');
    }
  }
})();
